var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooter1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 289,
    viewBox: "0 0 145 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-27.1861 261.096C-91.7007 245.926 -131.702 181.329 -116.532 116.814C-101.362 52.2994 -36.7649 12.2978 27.7497 27.4679C92.2643 42.638 132.266 107.235 117.096 171.75C101.926 236.264 37.3285 276.266 -27.1861 261.096ZM18.9545 64.8716C-24.9026 54.5589 -68.8159 81.7521 -79.1285 125.609C-89.4412 169.466 -62.248 213.38 -18.3909 223.692C25.4662 234.005 69.3795 206.812 79.6921 162.955C90.0048 119.098 62.8116 75.1842 18.9545 64.8716Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.38069 159.857C-11.9826 157.834 -17.3162 149.222 -15.2935 140.62C-13.2708 132.018 -4.65786 126.684 3.94408 128.707C12.546 130.729 17.8796 139.342 15.8569 147.944C13.8342 156.546 5.22126 161.88 -3.38069 159.857Z",
    fill: "#A1C6E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9381 165.616C71.646 149.233 70.6946 132.059 64.2403 116.915C57.7859 101.77 46.212 89.5536 31.4183 82.2707C16.6245 74.9879 -0.510172 73.0712 -17.1734 76.8354C-33.8366 80.5996 -49.0383 89.8209 -60.2834 102.986L-62.28 106.788C-52.1172 94.89 -31.0266 87.188 -15.9671 83.7861C-0.90759 80.3843 14.578 82.1164 27.948 88.6984C41.318 95.2803 51.778 106.321 57.6112 120.008C63.4443 133.695 69.85 155.486 65.5953 170.292L66.9381 165.616Z",
    fill: "#A1C6E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter1);
export default __webpack_public_path__ + "static/media/footer-1.94d535e62da5f6140f05106cd427605a.svg";
export { ForwardRef as ReactComponent };